import {Component, DestroyRef, inject} from '@angular/core';
import {FocusMeDirective} from '../../directives/focus-me.directive';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatHint} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {SupportApiService} from '../../services/support-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {finalize, map, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TicketInterface} from '../../interfaces/http.interface';
import {NgStyle} from '@angular/common';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';

@Component({
  selector: 'app-ticket-comment',
  imports: [
    FocusMeDirective,
    FormsModule,
    MatButton,
    MatFormField,
    MatHint,
    MatInput,
    ReactiveFormsModule,
    TopBarComponent,
    NgStyle,
    CdkTextareaAutosize
  ],
  templateUrl: './ticket-comment.component.html',
  styleUrl: './ticket-comment.component.scss'
})
export class TicketCommentComponent {
  public changeStatusLoading = false;
  private fb: FormBuilder = inject(FormBuilder);
  private supportApiService: SupportApiService = inject(SupportApiService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private destroyRef = inject(DestroyRef);
  public planningStatus = this.route.snapshot.queryParamMap.get('planningStatus');
  public commentForm: FormGroup = this.fb.group({
    reason_id: [this.route.snapshot.queryParamMap.get('reason_id')],
    comment: ['', [ Validators.maxLength(500)]]
  });

  public submitForm() {
    this.changeStatusLoading = true;
    if(this.route.snapshot.queryParamMap.get('planningStatus') === 'reopen') {
      this.supportApiService.reopenTicket(this.route.snapshot.queryParamMap.get('ticket_uuid'), this.commentForm.value)
        .pipe(
          tap((ticketData) => {
            this.navigateToChat({...ticketData.data, id: this.route.snapshot.queryParamMap.get('ticket_uuid') || ticketData.data.id});
          }),
          finalize(() => {
            this.changeStatusLoading = false;
          }),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe();
    } else {
      this.supportApiService.closeTicket(this.route.snapshot.queryParamMap.get('ticket_uuid'), this.commentForm.value)
        .pipe(
          tap((ticketData) => {
            this.navigateToChat({...ticketData.data, id: this.route.snapshot.queryParamMap.get('ticket_uuid') || ticketData.data.id});
          }),
          finalize(() => {
            this.changeStatusLoading = false;
          }),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe();
    }


  }

  private navigateToChat(chat: TicketInterface) {
    this.router.navigate([`/chat`], {queryParams: {ticket_uuid: chat.id, status: chat.status}});
  }
}
